import {KEY_JANUS, translate, selectLocale} from '@modifi/plugin-i18n'
import {connect} from '@modifi/redux'
import {compose, find, propEq} from 'ramda'

import {
  aSubmitForm,
  aResetForm,
  selectIsSubmitted,
  selectHasError,
  selectErrorMessage,
} from '../../store'
import {
  selectAll as selectCountries,
  selectNameByAlpha2 as selectCountryName,
  aEnsureCountries,
  selectIsLoaded as selectIsCountriesLoaded,
} from '../../../../custom-plugins/countries'
import SignUpForm from './SignUpForm'

const legacyPresetAndDefaultToFieldConfig = (fieldConfig, defaultFields, presetFields) => {
  const finalFieldConfig = fieldConfig || []
  const findFieldConfig = fieldName => find(propEq('fieldName', fieldName), finalFieldConfig)
  if (presetFields) {
    Object.entries(presetFields).forEach(([key, value]) => {
      if (!findFieldConfig(key)) {
        finalFieldConfig.push({
          fieldName: key,
          value,
          hidden: true,
        })
      }
    })
  }
  if (defaultFields) {
    Object.entries(defaultFields).forEach(([key, value]) => {
      if (!findFieldConfig(key)) {
        finalFieldConfig.push({
          fieldName: key,
          value,
        })
      }
    })
  }
  return finalFieldConfig
}

const sortCountries = list => {
  if (typeof window !== 'undefined' && window.Intl && typeof Intl.Collator === 'function') {
    const {compare} = Intl.Collator()
    return list.sort((a, b) => compare(a.label, b.label))
  }
  return list.sort((a, b) => a.label.localeCompare(b.label))
}
const sortCountryCodes = list =>
  list.sort((a, b) => {
    const aPrefix = parseInt(a.phonePrefix.replace(/\D+/g, ''), 10)
    const bPrefix = parseInt(b.phonePrefix.replace(/\D+/g, ''), 10)
    return aPrefix - bPrefix
  })
const mapStateToProps = state => ({
  isCountriesLoaded: selectIsCountriesLoaded(state),
  countryOptions: sortCountries(
    selectCountries(state)
      // removing United States Minor Outlying Islands from country field & country code as asked
      .filter(({alpha2}) => alpha2 !== 'UM')
      .map(({alpha2}) => ({
        label: selectCountryName(state, alpha2),
        value: alpha2,
      }))
  ),
  countryCodeOptions: sortCountryCodes(
    selectCountries(state)
      .filter(({phonePrefix, alpha2}) => alpha2 !== 'UM' && phonePrefix && phonePrefix.length > 0)
      .map(({alpha2, phonePrefix, flag}) => {
        const countryName = selectCountryName(state, alpha2)
        return {
          flag,
          phonePrefix,
          countryName,
          label: `${phonePrefix} ${countryName}`,
          value: alpha2,
        }
      })
  ),

  isSubmitted: selectIsSubmitted(state),
  hasError: selectHasError(state),
  errorMessage: selectErrorMessage(state),
  locale: selectLocale(state),
})

const mapDispatchToProps = {
  fetchCountries: aEnsureCountries,
  submitForm: aSubmitForm,
  resetForm: aResetForm,
}

export default compose(
  translate(KEY_JANUS),
  connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, ownProps) => {
    const combinedProps = {...ownProps, ...stateProps, ...dispatchProps}

    combinedProps.fieldConfig = legacyPresetAndDefaultToFieldConfig(
      combinedProps.fieldConfig || [],
      combinedProps.defaultFields,
      combinedProps.presetFields
    )

    return combinedProps
  })
)(SignUpForm)

export {fieldsShape} from './SignUpForm'
